import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ch",
  "use": "icon-icon-ch-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ch\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"red\" d=\"M0 0h512v512H0z\" />\n    <g fill=\"#fff\">\n      <path d=\"M96 208h320v96H96z\" />\n      <path d=\"M208 96h96v320h-96z\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol